import { Insole } from 'components/svgr/features/Insole';
import { Lining } from 'components/svgr/features/Lining';
import { Material } from 'components/svgr/features/Material';
import { Outsole } from 'components/svgr/features/Outsole';

type Props = {
  feature: string;
  className?: string;
};

const ProductFeatureIcon: React.FC<Props> = ({ feature, className }) => {
  switch (feature) {
    case 'material':
      return <Material className={className} />;
    case 'lining':
      return <Lining className={className} />;
    case 'insole':
      return <Insole className={className} />;
    case 'outsole':
      return <Outsole className={className} />;
    default:
      return null;
  }
};

export default ProductFeatureIcon;
